'use client';

import { Button } from '@plura/client/components';

const LearnMoreButton = () => {
  const handleClick = () => {
    const hero = document.getElementById('page-hero');
    if (hero) {
      const heroHeight = hero.offsetHeight;
      const heroTop = hero.offsetTop;
      window.scrollTo({
        top: heroTop + heroHeight,
        behavior: 'smooth'
      });
    }
  };

  return (
    <Button isStroke onClick={handleClick}>
      Learn More
    </Button>
  );
};

export default LearnMoreButton;

